export default __webpack_public_path__ + "static/media/leo.5bf48a93.png";